import { useEffect, useRef } from 'react';

export default function PhilosophyClosing() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .scale-in').forEach((el) => el.classList.add('visible'));
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 fade-up">
          <h2 className="text-2xl md:text-3xl font-normal text-gray-900 mb-8" style={{ fontFamily: 'Noto Serif JP, serif' }}>
            ここまで読んでくださったあなたへ
          </h2>
          <div className="flex justify-center mb-8 scale-in">
            <img
              alt="理事長"
              className="w-32 h-32 rounded-full object-cover"
              src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-892x959_v-fs_webp_d59d2706-6279-4b4b-90fe-f9a2c421054c.webp"
            />
          </div>
        </div>

        <div className="space-y-6 text-base text-gray-700 leading-relaxed">
          <div className="fade-up">
            <p>
              ここまでお読みいただいた時点で、<br />
              あなたはすでに<br />
              「何となく不安なまま矯正を考えている状態」<br />
              ではないはずです。
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-6 fade-up">
            <p className="text-sm">
              ・どこが判断の分かれ目になるのか<br />
              ・自分に合う可能性がある選択肢は何か<br />
              ・今すぐ決める必要があるのかどうか
            </p>
          </div>
          <div className="fade-up">
            <p>
              考えるべきポイントは整理できている状態だと思います。<br />
              あとは、その整理を専門家と一度すり合わせてみませんか?
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}